import Authorization from "../../generics/authorization";
import TabNavigation from "../../common/TabNavigation";
import { MFE_COMPONENT_IDS } from "../../utils/enums";

const xValue = 0;
const wValue = 12;

const pageProps = {
  filterDashlets: [{
    component: TabNavigation,
    name: "tab-nav",
    layout: { x: xValue, y: 0, w: wValue, h: 4 }
  }],
  componentId: MFE_COMPONENT_IDS.TRAFFIC_LOGS,
  dashlets: []
};

const Page = () => (<Authorization pageProps={pageProps} />);

export default Page;
